import { render, staticRenderFns } from "./index.vue?vue&type=template&id=3e1aa9da&lang=pug"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspaces/wuwow-junior-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e1aa9da')) {
      api.createRecord('3e1aa9da', component.options)
    } else {
      api.reload('3e1aa9da', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=3e1aa9da&lang=pug", function () {
      api.rerender('3e1aa9da', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/consultant/cloudClassroom/cloudClassroomTable/materialField/index.vue"
export default component.exports